import { countries } from './countries';
import { institutions } from './institutions';
import { resolutions } from './resolutions';
import { figures } from './figures'; // Membership

export var premiumMembershipPrice = function premiumMembershipPrice(country, institution) {
  var prices = {
    base_price: {
      factor: 1000
    },
    institution_price: institutions[institution],
    country_price: countries[country]
  };
  var keys = Object.keys(prices);
  var price = 1;
  keys.map(function (key) {
    price *= prices[key].factor;
  });
  return price;
};
export var standardMembershipPrice = function standardMembershipPrice(country, institution) {
  var prices = {
    base_price: {
      factor: 50
    },
    institution_price: institutions[institution],
    country_price: countries[country]
  };
  var keys = Object.keys(prices);
  var price = 1;
  keys.map(function (key) {
    price *= prices[key].factor;
  });
  return price;
};
export var FreeTrialPrice = function FreeTrialPrice(institution, country) {
  var prices = {
    base_price: {
      factor: 0
    },
    institution_price: institutions[institution],
    country_price: countries[country]
  };
  var keys = Object.keys(prices);
  var price = 1;
  keys.map(function (key) {
    price *= prices[key].factor;
  });
  return price;
}; // Shopping cart

export var plotPrice = function plotPrice(figure, country, institution, resolution) {
  var prices = {
    base_price: figures[figure],
    country_price: countries[country],
    resolution_price: resolutions[resolution],
    institution_price: institutions[institution]
  };
  var keys = Object.keys(prices);
  var price = 1;
  keys.map(function (key) {
    price *= prices[key].factor;
  });
  return price;
};